import api from '../../../app/api';
import getEndUsers from '../services/get-endUsers';
import deleteEndUser from '../services/delete-endUser';

export const accountsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getEndUsers: getEndUsers(build),
        deleteEndUser: deleteEndUser(build),
    }),
});

export const { useGetEndUsersQuery, useDeleteEndUserMutation } = accountsApi;
